import { INVALIDATE_QUERY_CACHE } from '.';

/**
 * Invalidate a React Query cache key from a Redux thunk. Caught by
 * `queryCacheMiddleware`, the single seam that touches the RQ client — thunks
 * just dispatch and stay free of the registry import. Keys live in
 * `queryKeys` (shared/api/query-client-registry).
 * @param {import('@tanstack/react-query').QueryKey} queryKey
 */
export const invalidateQueryCache = queryKey => ({
  type: INVALIDATE_QUERY_CACHE,
  payload: { queryKey },
});
